import {Component, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import {Location} from '@angular/common';
import {Router, NavigationExtras} from '@angular/router';
import {DomSanitizer} from '@angular/platform-browser';

import {AuthService} from '../../services/auth.service';
import {LogService} from '../../services/log.service';
import {PerfService} from '../../services/perf.service';

// import {DialogComponent} from '../../shared/components/dialog/dialog.component';
import {DialogComponent} from '../../modules/shared/components/dialog/dialog.component';

import * as uuid from 'uuid';
import * as url from 'url';
import * as querystring from 'querystring';

@Component({
	selector: 'landing',
	templateUrl: './landing.component.html',
	styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit, AfterViewInit {
	constructor(
		private location: Location,
		private router: Router,
		private sanitizer: DomSanitizer,

		private authService: AuthService,
		private log: LogService,
		private perf: PerfService
	) {}


	viewHeight = '';

	dialogTitle = '';
	dialogContent1 = '';
	dialogContent2 = '';
	dialogOk = '';
	dialogCancel = '';
	dialogData = '';
	helpUrlLabel = '';
	helpUrlString = '';
	@ViewChild('confirmDialog') confirmDialog: DialogComponent;


	ngOnInit() {
		window.scrollTo(0, 0);
		// console.log('LandingComponent, this.log.originalHref');
		// console.log(this.log.originalHref);

		this.viewHeight = (window.innerHeight - 64) + 'px';

		// console.log('About to test LandingComponent....!!');

		try {
			// let testKey = 'testLocalStorageKey';
			// let testValue = 'testLocalStorageValue-' + uuid.v4().replace(/-/g, '');
			// localStorage.setItem(testKey, testValue);

			// let testValueRead = localStorage.getItem(testKey);
			// if (testValueRead !== testValue) {
			// 	this.log.error('Browser does not support Local Storage, read incorrect value. testValue=' + testValue + ', testValueRead=' + testValueRead);
			// 	// this.showPrivateBrowsingDialog();
			// 	this.router.navigate(['site/home']);
			// } else {
				try {
					// localStorage.removeItem(testKey);

					let wasRedirected = this.authService.redirectIfAuthorized();
					console.log('wasRedirected = ' + wasRedirected);

					if (!wasRedirected) {
						let originalHref = this.log.originalHref;
						console.log('originalHref');
						console.log(originalHref);

						let theUrl: any;
						try {
							theUrl = url.parse(originalHref);
							// theUrl = new URL(originalHref);
							console.log('theUrl');
							console.log(theUrl);

							let parts = theUrl.pathname.split('/');
							console.log('pathname parts');
							console.log(parts);

							// General URL mappings
							// 1 - find any keyword mappings  (example: oauth)
							// 2 - find any alias mappings  (example: ptff)
							// 3 - find any alias mappings  (example: ptff)

							if (parts.length > 1) {
								let pathBase = parts[1].toLowerCase();
								switch (pathBase) {
								case 'oauth' :
									console.log('Found oauth !!');
									if (parts.length > 2) {
										let oauthEndpoint = parts[2].toLowerCase();
										switch (oauthEndpoint) {
										case 'callback' :
											console.log('Found oauth callback !!');

											let theQueryObject = querystring.parse(theUrl.query);
											console.log('theQueryObject');
											console.log(theQueryObject);

											let navigationExtras: NavigationExtras = {
												queryParams: { theQueryObject }
											};

											setTimeout(() => {
												console.log('Nav to /oauth/callback');
												this.router.navigate(['/oauth/callback', theQueryObject]);
												// this.router.navigate(['/oauth/callback', {queryParams: theQueryString}]);
												// this.router.navigate(['/oauth/callback', navigationExtras]);
												// this.router.navigateByUrl(theUrl.host + '/#/oauth/callback' + theUrl.search);
											}, 0);
											break;
										}
									} else {
										setTimeout(() => {
											console.log('Nav to /oauth');
											this.router.navigate(['/oauth']);
										}, 0);
									}
									break;

								case 'ptff' :
									console.log('Found ptff !!');
									setTimeout(() => {
										this.router.navigate(['festival/5dde71766d5342f39e8a0abfaaeab3f4/nextup']);
									}, 0);
									// this.router.navigate(['/site/home']);
									break;

								case 'ptfilmfest' :
									console.log('Found ptfilmfest !!');
									setTimeout(() => {
										this.router.navigate(['festival/5dde71766d5342f39e8a0abfaaeab3f4/nextup']);
									}, 0);
									// this.router.navigate(['/site/home']);
									break;

								case 'sedonafilmfestival' :
									console.log('Found sedonafilmfestival !!');
									// setTimeout(() => {
									// 	this.router.navigate(['festival/b3b5117aba6249e49084a02d7a1c2c6e/ballots']);
									// }, 1000);
									this.router.navigate(['/site/home']);
									// this.router.navigate(['festival/b3b5117aba6249e49084a02d7a1c2c6e/nextup']);
									break;

								default:
								// TODO!!! - try and lookup festival/organization domain, if found nav to that
									this.router.navigate(['/site/home']);
								}
							}
						} catch (err) {
							this.log.error('Error parsing href, originalHref = ' + originalHref);
							this.log.error(err);
							this.router.navigate(['/site/home']);
							return;
						}
					}
				} catch (ex) {
					this.log.error(ex);
					throw ex;
				}
			// }
		} catch (ex) {
			this.log.error('Browser does not support Local Storage.');
			this.log.error(ex);

			// this.showPrivateBrowsingDialog();
			this.router.navigate(['site/home']);
		}
	}


	ngAfterViewInit() {
		this.perf.markTabLoadEnd('landing');
	}


	showPrivateBrowsingDialog2() {
			this.dialogTitle = 'Local Storage Not Available';
			this.dialogContent1 = 'It appears that your browser does not support Local Storage.  Often this is the result of using "Private Browsing".  Please turn off private browsing and try again.';

			let browser = this.log.getBrowser();

			let tempUrl = '';
			this.helpUrlLabel = browser + ' instructions';

			switch (browser.toLowerCase()) {
				case 'mobile safari' :
				tempUrl = 'https://support.google.com/chrome/answer/95464?hl=en';
				break;

				case 'safari' :
				tempUrl = 'https://support.apple.com/kb/ph21413?locale=en_US';
				break;

				case 'chrome' :
				tempUrl = 'https://support.google.com/chrome/answer/95464?hl=en';
				break;

				case 'firefox' :
				tempUrl = 'https://support.mozilla.org/en-US/kb/private-browsing-use-firefox-without-history';
				break;

				case 'edge' :
				tempUrl = 'https://support.microsoft.com/en-us/instantanswers/34b9a3a6-68bc-510b-2a9e-833107495ee5/browse-inprivate-in-microsoft-edge';
				break;

			}
			if (tempUrl) {
				this.helpUrlString = tempUrl;
			}
// iOS
// https://support.google.com/chrome/answer/95464?hl=en

// Safari
// https://support.apple.com/kb/ph21413?locale=en_US

// Chrome
// https://support.google.com/chrome/answer/95464?hl=en

// FireFox
// https://support.mozilla.org/en-US/kb/private-browsing-use-firefox-without-history

// Edge
// https://support.microsoft.com/en-us/instantanswers/34b9a3a6-68bc-510b-2a9e-833107495ee5/browse-inprivate-in-microsoft-edge

			this.dialogContent2 = '';

			this.dialogData = '';
			this.dialogOk = 'OK';
			this.dialogCancel = '';

			let subscription = this.confirmDialog.showDialog()
				.subscribe((voteCompleteData: any) => {
					subscription.unsubscribe();
					this.log.action('Private browsing dialog closed.');
				});
	}
}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/components/landing/landing.component.ts